import { Box, Button, Container, Dialog, DialogContent, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import OTPView from "../../components/common/OTPView";
import {
    signUpEmailRequest, signUpPhoneRequest
} from "../../store/user/user.actions";
import UserAPI from "../../store/user/user.api";

function Authentication(props) {
    const [otp, setOTP] = useState("");
    const history = useNavigate();
    const dispatch = useDispatch();

    const [timeLeft, setTimeLeft] = useState(180);
    const { isLoading } = useSelector((state) => state.UserReducer);

    useEffect(() => {
        // exit early when we reach 0
        if (!timeLeft) {
            Swal.fire({
                title: "OTP Verification",
                text: "OTP Request Timed Out",
                icon: "error",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                showConfirmButton: false,
                cancelButtonText: "Close",
                customClass: {
                    cancelButton: "order-1 right-gap",
                    confirmButton: "order-2",
                    denyButton: "order-3",
                },
            });
            return;
        }

        // save intervalId to clear the interval when the
        // component re-renders
        const intervalId = setInterval(() => {
            setTimeLeft(timeLeft - 1);
        }, 1000);

        // clear interval on re-render to avoid memory leaks
        return () => clearInterval(intervalId);
        // add timeLeft as a dependency to re-rerun the effect
        // when we update it
    }, [timeLeft]);

    const handleChange = (otp) => {
        setOTP(otp);
    };

    const handleResend = () => {
        UserAPI.SendOTP({
            account: props.data.account || props.data.phone,
        })
            .then((x) => {
                setTimeLeft(180);
            })
            .catch((err) => {
                Swal.fire({
                    title: "Send OTP",
                    text: err.response.data.message,
                    icon: "error",
                    showCancelButton: true,
                    cancelButtonColor: "#d33",
                    showConfirmButton: false,
                    cancelButtonText: "Close",
                    customClass: {
                        cancelButton: "order-1 right-gap",
                        confirmButton: "order-2",
                        denyButton: "order-3",
                    },
                });
            });
    };

    const handleClick = async () => {
        if (otp.length === 6) {
            let data = props.data;
            data.otp = otp;
            data.deviceToken = "d2dfe7d1-21b7-4dd4-b16c-00774e2ea815";
            if (props.type === "phone") {
                dispatch(signUpPhoneRequest(data));
            } else if (props.type === "email") {
                dispatch(signUpEmailRequest(data));
            } else if (props.type === "Phone/Email") {
                UserAPI.VerifyOTP({
                    account: data.account,
                    otp: otp,
                })
                    .then(() => {
                        props.onConfirm(otp);
                    })
                    .catch((err) => {
                        Swal.fire({
                            title: "OTP Verification",
                            text: err.response.data.message,
                            icon: "error",
                            showCancelButton: true,
                            cancelButtonColor: "#d33",
                            showConfirmButton: false,
                            cancelButtonText: "Close",
                            customClass: {
                                cancelButton: "order-1 right-gap",
                                confirmButton: "order-2",
                                denyButton: "order-3",
                            },
                        });
                    });
            }
        }
    };

    const comp = (
        <Container maxWidth="sm">
            <Box textAlign="center" className="mb-4">
                <Typography variant="h5" component="h6">
                    A verification code has been sent to your{" "}
                    {props.type === "phone"
                        ? "SMS"
                        : props.type === "email"
                            ? "email"
                            : props.mode}
                    <br />
                    <b>
                        &nbsp;
                        {props.type === "phone"
                            ? props.data.phone
                            : props.type === "email"
                                ? props.data.account
                                : props.id}
                    </b>
                </Typography>
                <Box
                    textAlign="center"
                    justifyContent={"center"}
                    justifySelf="center"
                    display={"flex"}
                    alignSelf={"center"}
                    alignItems="center"
                    className="my-4"
                >
                    <OTPView onChange={(otp) => handleChange(otp)} />
                </Box>

                {timeLeft <= 0 ? (
                    <p className="second">
                        {" "}
                        Did not receive the code? <br />
                        <a href="javascript:;" onClick={() => handleResend()}>
                            Resend
                        </a>{" "}
                        or try a{" "}
                        <Link
                            to="/forgot-password"
                            className="forgot-pass"
                        >
                            different sign up method
                        </Link>
                    </p>
                ) : (
                    <p className="second mb-4">
                        If you did not receive the email, please make sure to
                        check your Spam folder
                        <span className="text-danger">{timeLeft}</span> seconds
                        left before the code expires.{" "}
                        <a href="javascript:;" onClick={() => handleResend()}>
                            Resend code
                        </a>
                    </p>
                )}
                <div className="form-group mt-4 widthel-100">
                    <Button
                        onClick={() => handleClick()}
                        disabled={otp.length !== 6}
                        color="primary"
                        variant="contained"
                        size="large"
                    >
                        {isLoading ? (
                            <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                            />
                        ) : (
                            "Submit"
                        )}
                    </Button>
                </div>
            </Box>
        </Container>
    );

    if (props.showpop) {
        return comp;
    }

    return (
        <Dialog open={true}>
            <DialogContent>
                <div className="ulalive_pricing">{comp}</div>
            </DialogContent>
        </Dialog>
    );
}

export default Authentication;
